export default __webpack_public_path__ + "static/media/BLR29.f5740977.jpg";